import React from "react";
import { animated } from "react-spring";

import Styles from "./NowFilterPlaceholder.styles";
import { NowFilterPlaceholderProps as Props } from "./NowFilterPlaceholder.types";
import usePlaceholderAnimation from "hooks/usePlaceholderAnimation";

const NowFilterPlaceholder: React.FC<Props> = props => {
  const animationStyle = usePlaceholderAnimation();

  const sessionButton = (
    <animated.div
      className="NowFilterPlaceholder__button"
      style={animationStyle}
    />
  );

  const sessions = (
    <div className="NowFilterPlaceholder__row__header">
      {sessionButton}
      {sessionButton}
      {sessionButton}
      {sessionButton}
    </div>
  );

  const theaters = (
    <>
      <animated.div
        className="NowFilterPlaceholder__theater"
        style={animationStyle}
      />
      {sessions}
    </>
  );

  const sessionCard = (
    <>
      <div className="NowFilterPlaceholder__card">
        <animated.div
          className="NowFilterPlaceholder__image"
          style={animationStyle}
        />
        <animated.div
          className="NowFilterPlaceholder__modality"
          style={animationStyle}
        />
        <animated.div
          className="NowFilterPlaceholder__title"
          style={animationStyle}
        />
        <animated.div
          className="NowFilterPlaceholder__language"
          style={animationStyle}
        />
      </div>
      <div className="NowFilterPlaceholder__movie">
        <div className="NowFilterPlaceholder__row">
          <animated.div
            className="NowFilterPlaceholder__subtitle"
            style={animationStyle}
          />
          {sessionButton}
        </div>
        <animated.div
          className="NowFilterPlaceholder__line"
          style={animationStyle}
        />
        {theaters}
        {theaters}
      </div>
    </>
  );

  return <Styles className="NowFilterPlaceholder">{sessionCard}</Styles>;
};

NowFilterPlaceholder.defaultProps = {};

export default NowFilterPlaceholder;
